module.exports = __webpack_public_path__ + "static/img/logo.2dca0e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/login/logo.png
// module id = alTn
// module chunks = 1